import React from 'react'
// import PropTypes from 'prop-types'
import Logo from '../../../../assets/Logo.png'
import User from '../../../../assets/user.png'

import './style.scss'

const InviteHeader = ({ userImage, userName }) => (
  <div className='header'>
    <img className='header_logo' src={Logo} alt='logo-mellro' />
    <img
      className='header_image'
      src={Boolean(userName?.large?.url) ? userName?.large?.url : User}
      alt='header'
    />

    <div className='header_name'>{userName}</div>
    <div className='header_invite'>Convidou você</div>
    <div className='header_context'>Você foi convidado pra fazer parte de uma negociação</div>
  </div>
)

// TODO: use ts
// InviteHeader.propTypes = {
//   userImage: PropTypes.object,
//   userName: PropTypes.string,
// }

export default InviteHeader
